import useFetch from "../hooks/useFetch";
import requests from "../utils/Request";
import MoveCard from "./MoveCard";
import Loading from "../utils/Loading";
const Trending = () => {
  const [data, loading] = useFetch(requests.fetchTrending);
  const url = "https://image.tmdb.org/t/p/original/";

  return (
    <div className="bg-gray-900 py-5">
      <h1 className="text-center font-bold text-gray-400 text-2xl tracking-wider">
        Trending Shows
      </h1>
      {loading && <Loading />}
      <div>
        <div className="px-3 py-5 sm:w-[90%] sm:ml-auto sm:mr-auto sm:grid items-center sm:grid-cols-2 lg:grid-cols-3 sm:gap-4">
          {data?.slice(2, 11).map((movie, index) => (
            <MoveCard
              key={index}
              image={`${url}${movie.backdrop_path}`}
              title={movie.original_name || movie.title}
              overview={movie.overview}
              vote_average={movie.vote_average}
              release_date={movie.release_date}
              vote_count={movie.vote_count}
              poster_path={`${url}${movie.poster_path}`}
              popularity={movie.popularity}
              media_type={movie.media_type}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Trending;
